<template>
	<div class="page-mdl">
		<!-- 筛选 -->
		<div class="mask-bg" v-if="screenIndex>=0" @click="openScreen(-1)"></div>
		<div class="screen-box">
			<div class="screen-btns">
				<span v-for="(item,index) in screenList" :key="index"
					@click="openScreen(index)">{{item.index==0?item.title:item.value}}</span>
			</div>
			<div class="screen-pops" v-if="screenIndex>=0">
				<div class="pop" v-for="(item,index) in screenList" :key="index" v-if="screenIndex==index">
					<ul :class="{list:index!=2,list2:index==2}" >
						<li :class="{act:item.index==index2}" v-for="(item2,index2) in item.list" :key="index2"
							@click="changeScreen(item.type,item2,index,index2)">{{item2.title}}</li>
					</ul>
				</div>
			</div>
		</div>
		
		
		<div class="course-box">
			
				<van-list
					v-if="listInfo.list.length>0"
					v-model="listInfo.loading" 
					:finished="listInfo.finished"
					finished-text="没有更多了" 
					:offset="30"
					@load="getCourseList"
				>
					<ul class="course-list">
						<li v-for="(item,index) in listInfo.list" :key="item.courseId" @click="goCourseDetail(item)" >
							<div class="img-box">
								<img :src="item.courseImg || dfImg" alt="">
								<div v-if="item.courseLevelName" class="label">{{item.courseLevelName}}</div>
								<div class="visit">{{item.allChooseCount || 0}}人观看</div>
							</div>
							<div class="info">
								<h4 class="title">{{item.courseName}}</h4>
								<p>{{item.orgName}} | {{item.teacherName}}</p>
								<div class="btm">
									<span class="status" :class="item.offerCoursesClass">{{item.offerCoursesName}}</span>
									<div class="date">{{item.termName}}</div>
								</div>
							</div>
						</li>
					</ul>
				</van-list>
				<van-empty v-if="listInfo.finished && !listInfo.list.length>0"  description="没找到相应课程" />
			
		</div>
		
	</div>
</template>


<script>
import { getList } from '@/static/js/list-vant.js'
export default {
	data () {
		return {
			maskShow:false,
			screenIndex:-1,
			screenList:[
				{ title:'类别', type:'courseLevel', value:'', index:0, popShow:false, list:[
					{ title:'全部', val:'' },
					{ title:'省级精品', val:1 },
					{ title:'国家精品', val:2 },
					{ title:'省级线上一流', val:3 },
					{ title:'国家线上一流', val:4 },
				]},
				{ title:'层次', type:'courseMajorLevel', value:'', index:0, popShow:false, list:[
					{ title:'全部', val:0 },
					{ title:'本科', val:1 },
					{ title:'高职', val:2 }
				]},
				{ title:'学科', type:'courseSubject', value:'', index:0, popShow:true, list:[
					// { title:'全部', val:'',  level:0},
					// { title:'哲学', val:'哲学', level:1 },
					// { title:'文学', val:'文学', level:1 },
					// { title:'教育学', val:'教育学', level:1 },
					// { title:'历史学', val:'历史学', level:1 },
					// { title:'农学', val:'农学', level:1 },
					// { title:'医学', val:'医学', level:1 },
					// { title:'管理学', val:'管理学', level:1 },
					// { title:'法学', val:'法学', level:1 },
					// { title:'理学', val:'理学', level:1 },
					// { title:'工学', val:'工学', level:1 },
					// { title:'经济学', val:'经济学', level:1 },
					// { title:'艺术学', val:'艺术学', level:1 },
					
					// { title:'资源环境与安全大类', val:'资源环境与安全大类',level:2 },
					// { title:'交通运输大类', val:'交通运输大类',level:2 },
					// { title:'食品药品与粮食大类', val:'食品药品与粮食大类',level:2 },
					// { title:'医药卫生大类', val:'医药卫生大类',level:2 },
					// { title:'文化艺术大类', val:'文化艺术大类',level:2 },
					// { title:'农林牧渔大类', val:'农林牧渔大类',level:2 },
					// { title:'土木建筑大类', val:'土木建筑大类',level:2 },
					// { title:'水利大类', val:'水利大类',level:2 },
					// { title:'生物与化工大类', val:'生物与化工大类',level:2 },
					// { title:'新闻传播大类', val:'新闻传播大类',level:2 },
					// { title:'教育与体育大类', val:'教育与体育大类',level:2 },
					// { title:'能源动力与材料大类', val:'能源动力与材料大类',level:2 },
					// { title:'装备制造大类', val:'装备制造大类',level:2 },
					// { title:'轻工纺织大类', val:'轻工纺织大类',level:2 },
					// { title:'电子信息大类', val:'电子信息大类',level:2 },
					// { title:'财经商贸大类', val:'财经商贸大类',level:2 },
					// { title:'公安与司法大类', val:'公安与司法大类',level:2 },
					// { title:'旅游大类', val:'旅游大类',level:2 },
					// { title:'公共管理与服务大类', val:'公共管理与服务大类',level:2 },
				]},
				{ title:'状态', type:'offerCoursesStu', value:'', index:0, popShow:false, list:[
					{ title:'全部', val:0 },
					{ title:'即将开课', val:1 },
					{ title:'开课中', val:2 },
					{ title:'已结课', val:3 },
					{ title:'暂未开课', val:4 },
				]}
			],
			courseLevel:'',
			offerCoursesStu:0,
			courseMajorLevel:0,

			courseSubject:'',
			filtro:'',	//关键词搜索

			listInfo:{	//开放课程
				list:[],
				pageNum:1,
				pageSize:10,
				total:0,
				loading: true,
				finished: false,
			},
		}
	},
	
	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		this.getSubjectList()
		this.getCourseList(true)
	},
  
	computed:{
		
	},
  
	methods:{
		
		openScreen(index){
			if(this.screenIndex==index){
				this.screenIndex = -1
			}else{
				this.screenIndex = index
			}
		},
		
		//切换筛选类型
		changeScreen(typeName,childrenItem,parentIndex,childrenIndex){
			this[typeName] =childrenItem.val
			// if(typeName=='courseMajorLevel' && val==0){
			// 	this.courseSubject = ''
			// }
			this.screenList.forEach((item,index)=>{
				if(parentIndex==index){
					item.index = childrenIndex
					item.value = childrenItem.title
				}
			})
			this.getCourseList(true)
			this.screenIndex = -1
			window.scrollTo(0,0);
		},
		
		//查询教学计划课程数据列表
		getCourseList(isReach){
			const {  courseLevel, courseSubject, offerCoursesStu, filtro, courseMajorLevel } = this
			
			getList({
				url:`/jxedu/api/site/teachPlanList`,		//必传，接口地址，不用前缀
				page:this,				//必传,当前页面的this
				isReach,
				listName:'listInfo',
				data:{
					//schoolType,	//院校类型 1本科院校 2高职高专 3开发大学
					courseLevel,	//课程级别：0省级精品 1国家精品 2省级线上一流 3国家线上一流
					courseSubject,	//所属学科
					offerCoursesStu,	//开课状态(0:全部,1:即将开课,2:开课中,3:已结课,4:暂未开课)
					courseMajorLevel,	//课程层次:1本科 2高职
					filtro,	//关键词搜索
				},
				cbListFn:(res)=>{
					return res.rows	//这里接口返回的数据层级，看列表属于哪一级
				},
				handleFn:(item)=>{
					switch(item.courseLevel){	//课程级别：0普通网课 1联盟精品课 2国家精品课 3省级精品课
						case 0: item.courseLevelName = ''; item.courseLevelClass = ''; break;
						case 1: item.courseLevelName = '省级精品'; item.courseLevelClass = 'blue'; break;
						case 2: item.courseLevelName = '国家精品'; item.courseLevelClass = 'orange'; break;
						case 3: item.courseLevelName = '省级线上一流'; item.courseLevelClass = 'green'; break;
						case 4: item.courseLevelName = '国家线上一流'; item.courseLevelClass = 'red'; break;
					}
					
					switch(item.offerCoursesStu){	//开课状态：0:全部，1:即将开课,2:开课中,3:已结课,4:暂未开课
						case 1: item.offerCoursesName = '即将开课'; item.offerCoursesClass = 'orange'; break;
						case 2: item.offerCoursesName = '开课中'; item.offerCoursesClass = 'blue'; break;
						case 3: item.offerCoursesName = '已结课'; item.offerCoursesClass = 'gray'; break;
						case 4: item.offerCoursesName = '暂未开课'; item.offerCoursesClass = 'gray'; break;
					}
					return item
				}
			})
		},
		
		
		//切换分页
		changePaging(num,obj){
			const { pageNum, pagingList } = this[obj]
			if(num < 1 || num > pagingList.length || pageNum == num){
				return
			}
			this[obj].pageNum = num
			switch(obj){
				case 'listInfo':  //开放课堂
					this.getCourseList();
					break;
			}
		},
		
		//获取学科数据
		getSubjectList(){
			this.$axios({
				url:`/jxedu/api/site/findOrgDataDict`,
			}).then(res=>{
				let datas = res.data
				let list = datas.higherList
				list = list.concat(datas.regularList)
				list = list.map(item=>{
					return {
						title:item.dataLabel,
						val:item.dataValue,
						level:(item.typeCode=='gz_course_subject')?2:1
					}
				})
				list.unshift({
					title:'全部',
					val:'',
					level:0
				})
				console.log('list',list)
				this.screenList[2].list = list
			})
		},

	}
}
</script>

<style lang="less" scoped>
@vm: 7.5vw;
@import '~@/static/css/m-course.less';
.screen-box{
	height:94/@vm; background:#fff; padding:0 32/@vm; position:relative; z-index:10001;
	position:fixed; top:0; left:0; width:100%; box-sizing: border-box;
	.screen-btns{
		display:flex; justify-content: space-between;
		span{ 
			display:inline-flex; align-items: center; height:94/@vm; padding-top:18/@vm; font-size:28/@vm; color:#666;
			padding-right:26/@vm; position:relative; box-sizing: border-box;
			&::after{
				content:''; width:0px; height:0px; overflow:hidden; font-size:0px; display:inline-block; 
				border-style:solid; border-width:8/@vm 6/@vm 0 6/@vm; border-color:#666 transparent transparent transparent;
				position:absolute; right:0; top:56%;
			}
			&.act::after{ transform:rotate(180deg);}
		}
	}
	.screen-pops{
		position:absolute; top:94/@vm; left:0; width:100%; background:#fff; border-radius:0 0 24/@vm 24/@vm;
		.pop{
			.list{
				max-height:630/@vm; overflow:auto; 
				li{ 
					display:flex; align-items: center; padding:0 32/@vm; border-bottom:1px solid #eee; height:100/@vm; 
					&:last-child{border-bottom:none;}
					&:active,
					&.act{ color:#1677FF; }
				}
			}
			.list2{
				padding:32/@vm; max-height:630/@vm; overflow:auto; 
				li{ 
					display:flex; align-items: center; justify-content: center; padding:0 24/@vm; width:214/@vm; height:84/@vm; 
					float:left; margin-right:22/@vm; margin-bottom:20/@vm; background:#F6F6F6; box-sizing: border-box; text-align: center;
					font-size:26/@vm; color:#666666; border-radius:6/@vm; overflow : hidden;
					&:nth-child(3n+3){ margin-right:0;}
					&:active,
					&.act{ color:#1677FF; }
				}
			}
		}
	}
}
.course-box{
	padding:114/@vm 32/@vm;
}
</style>



// WEBPACK FOOTER //
// src/pages/course-list/tpl-mobile.vue